import { AVERAGE_AGE_GROUP_YEARS } from '../model/AVERAGE_AGE_GROUP_YEARS'
import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { MAX_AGE } from '../model/MAX_AGE'
import { averageRounded } from './averageRounded'
import { getAge } from './getAge'
import { median } from './median'

const valuesByGroupMale = new Map<number, IAverageAge>()
const valuesByGroupFemale = new Map<number, IAverageAge>()

export interface IAverageAge {
	average: number
	median: number
	basedOn: number
}

export function getAverageAge(
	data: IData,
	birthDate: string,
	isMale: boolean,
): Readonly<IAverageAge> {
	const valuesByDecade = isMale ? valuesByGroupMale : valuesByGroupFemale
	const groupStart =
		Math.floor(parseInt(birthDate.slice(0, 4), 10) / AVERAGE_AGE_GROUP_YEARS) *
		AVERAGE_AGE_GROUP_YEARS
	const groupStartString = groupStart + ''
	let value = valuesByDecade.get(groupStart)
	if (value == null) {
		const groupEnd = groupStart + AVERAGE_AGE_GROUP_YEARS
		const groupEndString = groupEnd + ''
		let persons: IPerson[] = []
		persons = persons.concat(
			Object.values(data.personsById).filter(
				(person) =>
					person.isMale === isMale &&
					person.birthDate &&
					person.birthDate >= groupStartString &&
					person.birthDate < groupEndString,
			),
		)
		const values: number[] = []
		for (const person of persons) {
			if (person.deathDate) {
				const age = getAge(person.birthDate, person.deathDate)
				if (age != null && age > 18) values.push(age)
			} /* else if (person.birthDate! >= AVERAGE_AGE_BIRTH_DATE_CUTOFF) {
				values.push(MAX_AGE)
			} */
		}
		value = {
			average: values.length > 0 ? averageRounded(values) : MAX_AGE / 2,
			median: values.length > 0 ? median(values) : MAX_AGE / 2,
			basedOn: values.length,
		} satisfies IAverageAge
		valuesByDecade.set(groupStart, value)
	}
	return value
}
